import { render } from "./ListBus.vue?vue&type=template&id=0ec6531d&scoped=true"
import script from "./ListBus.vue?vue&type=script&lang=js"
export * from "./ListBus.vue?vue&type=script&lang=js"

import "./ListBus.vue?vue&type=style&index=0&id=0ec6531d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec6531d"]])

export default __exports__